import 'cropperjs/dist/cropper.css';
import './index.css';
import './picture.css';

import * as React from 'react';
import Cropper from 'react-cropper';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Member from 'src/entities/Member';

import { updateMember } from '../../actions/member';
import Navigation from '../Navigation/global';

interface IProps {
  account: Member;
  updateMember: (member: Member) => void;
}

interface IState {
  account: Member;
  picture: string;
  canvas: HTMLCanvasElement | null;
}

class PictureComponent extends React.Component<IProps, IState> {
  cropper: any;

  constructor(props: any) {
    super(props);
    this.state = {
      account: this.props.account,
      picture: '',
      canvas: null
    };

    this.onChangePicture = this.onChangePicture.bind(this);
    this.updateMember = this.updateMember.bind(this);
    this.crop = this.crop.bind(this);
  }

  render() {
    return (
      <div id="AccountPicture">
        <Navigation isLogoOnly={true} />

        <div id="Tabs">
          <Link to="/settings/account">
            <div className="Tab">登録情報</div>
          </Link>
          <Link to="/settings/password">
            <div className="Tab">パスワード</div>
          </Link>
          <div className="Tab TabSelected">画像</div>
        </div>
        <div id="Content">
          <div className="ContentItem">
            <label>画像を選択</label>

            <input type="file" onChange={this.onChangePicture} />
          </div>

          {this.state.picture !== '' ? (
            <div id="Guide">
              適当な位置で画像を切り取って、更新ボタンをクリックしてください。
            </div>
          ) : null}

          <div id="Cropper">
            <Cropper
              ref={cropper => {
                this.cropper = cropper;
              }}
              src={this.state.picture}
              style={{ width: '100%', height: '35rem' }}
              aspectRatio={1}
              guides={false}
              crop={this.crop}
            />
          </div>

          <button onMouseUp={this.updateMember} onTouchEnd={this.updateMember}>
            更新
          </button>
        </div>
      </div>
    );
  }

  onChangePicture(e: any) {
    this.setState({
      picture: URL.createObjectURL(e.target.files[0])
    });
  }

  updateMember(e: any) {
    const canvas = this.state.canvas as HTMLCanvasElement;

    canvas.toBlob((blob: Blob) => {
      const THRESHOLD = 100000;
      let data = '';
      if (THRESHOLD <= blob.size) {
        const capacityRatio = THRESHOLD / blob.size;
        data = canvas.toDataURL('image/jpeg', capacityRatio);
      } else {
        data = canvas.toDataURL('image/jpeg');
      }

      const account = Object.assign({}, this.state.account);
      account.profile = data;
      this.props.updateMember(account);
    });
  }

  crop() {
    this.setState({
      canvas: this.cropper.getCroppedCanvas()
    });
  }

  base64ToBlob(base64: any) {
    const base64Data = base64.split(',')[1];
    const data = window.atob(base64Data);
    const buff = new ArrayBuffer(data.length);
    const arr = new Uint8Array(buff);
    let blob;
    let i;
    let dataLen;
    for (i = 0, dataLen = data.length; i < dataLen; i++) {
      arr[i] = data.charCodeAt(i);
    }
    blob = new Blob([arr], { type: 'image/jpeg' });
    return blob;
  }
}

const mapStateToProps = (state: any) => ({
  account: state.Account
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateMember(member: Member) {
      dispatch(updateMember(member));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PictureComponent);



// WEBPACK FOOTER //
// ./src/components/Account/picture.tsx